'use strict';

/**
 * The idea of this utils is have a common place tu put helper functions that will
 * consume the different types of DashboardModals.
 */
const DateUtils = require('utils/DateUtils'),
    ContentUtils = require('utils/ContentUtils'),
    NumberUtils = require('utils/NumberUtils'),
    SessionStore = require('stores/SessionStore'),
    DashboardServiceCache = require('services/DashboardServiceCache'),
    _ = require('lodash'),
    {
        SECONDARY_TASK,
        TASK_NON_VISIBLE
    } = require('constants/AppConstants');

/**
 * Retrieve the index of Tab which need to be open given information.
 * @param filtrationDate
 * @param fermenterTasks
 * @param packagingTasks
 * @param dataClicked
 * @param isFermenterTankClicked
 * @returns {number}
 */
function getTabSelectedIndex(filtrationDate, fermenterTasks, packagingTasks, dataClicked, isFermenterTankClicked, tankTypeClicked) {
    if (DateUtils.toDateText(filtrationDate) === DateUtils.toDateText(dataClicked) && isFermenterTankClicked) {
        return 1; // this is the special case that the date of filtration exist on packaging task too, so we need to know which type of task was clicked
    }

    var dateText = DateUtils.toDateText(dataClicked);
    var fermenterTask = _.find(fermenterTasks, function (task) {
        return task.date === dateText;
    });
    var packagingTask = _.find(packagingTasks, function (task) {
        return task.date === dateText;
    });

    if (tankTypeClicked === 'BH') {
        // enter here means that was clicked a brewhouse batch
        return 1;
    }
    return packagingTask ? 3 : (isFermenterTankClicked && fermenterTask) ? 2 : 0;
}

/**
 * Analyze and fill if need to complete the products of each of bathes from the order.
 * @param oldState
 * @param nextState
 * @return {*}
 */
function fillEachBatchWithProductMissing(oldState, nextState) {
    if (SessionStore.isFullPaidVersion()) {
        const haveMoreVolumeThanBefore = NumberUtils.isGreater(nextState.orderVolume, oldState.orderVolume);
        const haveMoreAmountBatchsThanBefore = (_.get(oldState, 'order.batchs.length') || 0) < _.get(nextState, 'order.batchs.length');

        if (haveMoreVolumeThanBefore && haveMoreAmountBatchsThanBefore) {
            // only make sense enter here when the volume are larger than before
            // which means we could need more batch to hydrate
            const batchs = _.get(nextState, 'order.batchs');
            const productIcons = DashboardServiceCache.getProductIcons();
            const fullProducts = DashboardServiceCache.getProducts();
            const productItems = DashboardServiceCache.getProductItems();
            const currentBeerStyleId = _.get(nextState, 'styleBeerSelected.id');

            const newBatchs = _.map(batchs, batch => {
                const notHaveProducts = (_.get(batch, 'products.length') || 0) === 0;
                if (notHaveProducts) {
                    const currentIcon = _.get(batch, 'name');

                    // icons filtered by current task name
                    const productIconsByTaskName = _.filter(productIcons, productIcon => {
                        return _.get(productIcon, 'icon.iconDetail.name') === currentIcon ||
                          _.get(productIcon, 'icon.iconDetail.displayName') === currentIcon;
                    });

                    if (ContentUtils.isNotEmptyArray(productIconsByTaskName)) {

                        // hydrate each product icon with product
                        const productIconsWithProducts = _.map(productIconsByTaskName, productIcon => {
                            let productTarget = _.find(fullProducts, product => _.get(product, 'id') === _.get(productIcon, 'product.id'));
                            productIcon = _.merge(productIcon, productTarget);
                            productIcon.product = productTarget;
                            return productIcon;
                        });

                        // filter full product by current beer stlye
                        const emptyProducts = _.filter(productIconsWithProducts, productIcon => +_.get(productIcon, 'product.beerStyle.id') === +currentBeerStyleId);
                        if (ContentUtils.isNotEmptyArray(emptyProducts)) {

                            // hydrate each of product with their productItems
                            const emptyProductsHydratedWithItems = _.map(emptyProducts, emptyProduct => {
                                emptyProduct.items = _.filter(productItems, productItem => _.get(productItem, 'product.id') === _.get(emptyProduct, 'id'));
                                return emptyProduct;
                            });

                            // assign finally each product needed by batch
                            batch.products = emptyProductsHydratedWithItems;
                        }
                    }
                }
                return batch;
            });

            nextState = _.set(nextState, 'order.batchs', newBatchs);
        }
    }

    return nextState;
}


/**
 * Retrieve the non-select menu items that will be consume the drop-down menus.
 * @argument {String} text                  the text that will be displayed.
 * @return {Array}
 */
function getNonSelectedMenuItem(text) {
    return [{'payload': 0, 'text': text}];
}

/**
 * Check if exist more than one task for this task, in case that exist two task
 * retrieve the SECONDARY_TASK insted of the default tasks (BREW_TASK, PACKAGING_TASK, FILTRATION_TASK)
 * @param existingTasks
 * @returns {*}
 */
function retrieveCustomTask(existingTasks) {
    if (existingTasks && existingTasks.length) {
        if (existingTasks.length === 1) {
            return existingTasks[0];
        } else {
            return _.find(existingTasks, task => task.type === SECONDARY_TASK);
        }
    }
}


function isSingle(isFVAllowed, isBTAllowed) {
    return isFVAllowed === false || isBTAllowed === false;
}

/**
 * Filter for type of tanks and convert in drop-down menu item model.
 * @argument {String} type                  Type of that that will be filter.
 * @argument {Array} tanks                  Tanks that will use for convert in properly menu item model.
 * @return {Array}
 * @private
 */
function toTankMenuItems(type, tanks, locatorPrefix = '') {
    return _.filter(tanks, function (tank) {
        return tank.type === type;
    }).map(function (tank, index) {
        return {
            payload: index + 1,
            text: `${tank.name} - ${tank.volume}${tank.unit || 'v'}`,
            type: tank.type,
            column: tank.column,
            volume: tank.volume,
            tankObj: tank,
            locatorId: locatorPrefix + (index + 1)
        };
    });
}

/**
 * Convert to raw Configuration Task, to a ready to use task.
 * @param {Array} task                      The raw task.
 * @param {String} fromDate                 The first that we use as reference to calculate the `date` field of real task.
 * @param {Array} menuItems                 The Menu item to calculate the index position of the real task that will need to take.
 * @private
 * @returns {Array}
 */
function toConcreteTask(tasks, fromDate, menuItems, tankType) {
    return _.map(tasks, task => {
        const date = _.get(task, 'date', DateUtils.addDaysTextBasicFormat(fromDate, (task.day - 1)));
        const payload = _.findIndex(menuItems, menuItem => menuItem.displayName === _.get(task, 'typeTask', _.get(task, 'name')) || menuItem.name === _.get(task, 'typeTask', _.get(task, 'name')));
        const name = _.get(task, 'typeTask', _.get(task, 'name'));
        const label = _.get(task, 'label', '');
        const type = _.get(task, 'type', SECONDARY_TASK);
        const description = _.get(task, 'description', '');
        const icon = _.get(task, 'icon', '');
        return {
            icon,
            date,
            payload,
            name,
            label,
            description,
            type,
            tankType,
            tasks: menuItems,       // We need to load all the tasks in order to hydrate the menu items that will contain this particular task
            isConfiguration: true   // flag that allow us to remove this kind of task if we need to re-calculate again.
        };
    });
}

/**
 * Retrieve an empty task.
 * @param {String} date                     Date of task
 * @param {String} taskType (Optionally)    The task type like BREW_TASK, FILTRATION_TASK, PACKAGING_TASK, SECONDARY_TASK, etc.
 * @param {String} name     (Optionally)    The name of the task.
 * @return {Object}
 */
function toEmptyTask(date, taskType = SECONDARY_TASK, name = TASK_NON_VISIBLE) {
    let existingTask = {};
    existingTask.name = name;
    existingTask.date = date;
    existingTask.label = '';
    existingTask.description = '';
    existingTask.type = taskType;

    return existingTask;
}

function isToggleChange(nextProps, oldProps) {

    let isChanged = false;

    if (nextProps.isBHAllowed !== oldProps.isBHAllowed) {
        return true;
    }

    if (nextProps.isFVAllowed !== oldProps.isFVAllowed) {
        return true;
    }

    if (nextProps.isBTAllowed !== oldProps.isBTAllowed) {
        return true;
    }

    return isChanged;
}

/**
 * Search if exist some custom task that have an conflict with the a default task, and replace default task if
 * will need it, without change their type of task. (In order to work the logic about brew task)
 *
 * @param existingTasks
 * @private
 * @returns {*}
 */
function removeDefaultTaskWhenExistCustom(existingTasks) {
    let clonedExistingTask = _.cloneDeep(existingTasks);
    const conflicTask = _.filter(_.values(_.groupBy(clonedExistingTask, 'date')), task => task.length > 1);
    if (conflicTask && conflicTask.length) {
        const properlyTask = _.filter(_.values(_.groupBy(clonedExistingTask, 'date')), task => task.length === 1);
        const defaultTask = _.filter(_.flatten(conflicTask), taskRepeat => taskRepeat.type !== 'SECONDARY_TASK');
        const customTasks = _.filter(_.flatten(conflicTask), taskRepeat => taskRepeat.type === 'SECONDARY_TASK');
        const customTasksWithProperlyType = _.map(customTasks, customTask => {
            const type = _.get(_.find(defaultTask, task => task.date === customTask.date), 'type', '');
            if (type !== '') {
                customTask.type = type;
            }
            return customTask;
        });

        return _.flatten(_.concat(properlyTask, customTasksWithProperlyType));
    } else {

        return existingTasks;
    }
}

/**
 * Retrieve the index necessary for fermenter tank of the drop down menu component.
 * @argument {HTMLElement} menuItems            the menu items need it to take the target index.
 * @argument {Object} order                     that will be used to get fermenter tank properties
 * @return {Object}
 * @private
 */
function getFermenterTank(menuItems, order) {
    var fermenterTank = {index: 0, item: null}; // by default
    menuItems.forEach(function (menuItem) {
        if (menuItem.column === _.get(order, 'fermenterTank.column')) {
            fermenterTank.index = menuItem.payload;
            fermenterTank.item = menuItem;
        }
    });

    return fermenterTank;
}

function getTasksFromProcess(newProcess, state) {
    if (isBrewingProcess(newProcess))  {
        return _.get(state, 'order.batchs');
    }

    if (_.get(state, 'order.isSingle')) {
        return _.get(state, 'singleTasks');
    }

    if (isFermentingProcess(newProcess)) {
        return _.get(state, 'fermenterTasks');
    }

    if(isPackagingProcess(newProcess)) {
        return _.get(state, 'packagingTasks');
    }
}

/**
 * Retrieve the index necessary for briteTank drop of the down menu component.
 * @argument {HTMLElement} menuItems            the menu items need it to take the target index.
 * @argument {Object} order                     that will be used to get brite tank properties.
 * @return {Object}
 * @private
 */
function getBriteTank(menuItems, order) {
    var briteTank = {index: 0, item: null}; // by default
    menuItems.forEach(function (menuItem) {
        if (menuItem.column === _.get(order, 'briteTank.column')) {
            briteTank.index = menuItem.payload;
            briteTank.item = menuItem;
        }
    });

    return briteTank;
}

/**
 * Retrieve the index necessary for single tank of the down menu component.
 * @argument {HTMLElement} menuItems            the menu items need it to take the target index.
 * @argument {Object} order                     that will be used to get brite tank properties.
 * @return {Object}
 * @private
 */
function getSingleTank(menuItems, order) {
    var briteTank = {index: 0, item: null}; // by default
    menuItems.forEach(function (menuItem) {
        if (menuItem.column === _.get(order, 'singleTank.column')) {
            briteTank.index = menuItem.payload;
            briteTank.item = menuItem;
        }
    });

    return briteTank;
}

function setTaskIds(tasks, taskType) {
    return _.map(tasks, task => {
        task.taskId = `${taskType}_${task.name}_${task.date}`;
        return task;
    });
}

/**
 * Retrieve the index necessary for style beer of the drop down menu component.
 * @argument {HTMLElement} menuItems            the menu items need it to take the target index.
 * @argument {Object} order                     that will be used to get style beer properties
 * @return {Object}
 * @private
 */
function getStyleBeer(menuItems, order) {
    var styleBeer = {index: 0, item: null}; // by default
    menuItems.forEach(function (menuItem) {
        if (menuItem.id === _.get(order, 'styleBeer.id')) {
            styleBeer.index = menuItem.payload;
            styleBeer.item = menuItem;
        }
    });

    return styleBeer;
}


function formatProperOrderSelected(preOrderSelected) {
    let newFormatOrder = _.cloneDeep(preOrderSelected);
    const tankSelected = newFormatOrder.tankSelected;

    if (tankSelected) {
        newFormatOrder.tankSelected.tankObj = {
            id: tankSelected.id,
            column: tankSelected.column,
            type: tankSelected.type
        };
    }

    return newFormatOrder;
}

/**
 * The format that will send the request against to the API.
 * @param orderProcess
 * @return {*}
 */
function formatOrderProcess(ordersProcess) {

    if (Array.isArray(ordersProcess)) {
        // change the format of object
        const processFormatted = _.map(ordersProcess, brewProcess => formatOrderProcess(brewProcess));
        // remove the null positions of the array
        return _.filter(processFormatted, process => process);
    }

    const processId = _.get(ordersProcess, 'processId', _.get(ordersProcess, 'orderProcessHydrated.id'));
    const taskId = _.get(ordersProcess, 'taskId');

    if (!processId || !taskId) {
        // just not need to take care for this kind of process, we don't need it
        return null;
    }

    return {
        processId,
        taskId,
        processSection: ordersProcess.processSection,
        fromDate: ordersProcess.fromDate,
        fromHour: ordersProcess.fromHour,
        toDate: ordersProcess.toDate,
        toHour: ordersProcess.toHour,
        note: _.get(ordersProcess, 'note', _.get(ordersProcess, 'orderProcessHydrated.note'))
    };
}

function hydrateOrderWithTheirProcess(order) {
    if (!order || ContentUtils.isEmptyArray(order.process)) {
        return order;
    }

    const processList = _.get(order, 'process', []);


    Array.from(['singleTasks', 'fermenterTasks', 'packagingTasks', 'batchs'])
        .filter(fieldName => order[fieldName])
        .forEach(fieldName => {
            const tasks = order[fieldName];
            order[fieldName] = fillWithProcess(tasks, processList);
        });

    order.process = null;

    return order;
}

function fillWithProcess(tasks = [], processList = []) {
    const fermentingProcessList = processList.filter(isFermentingProcess);
    const packagingProcessList = processList.filter(isPackagingProcess);
    const brewingProcessList = processList.filter(isBrewingProcess);

    return tasks.map(task => {
        if (isFermentingTask(task)) {
            const targetProcess = fermentingProcessList.find(process => process.fromDate === task.date);
            if (targetProcess) {
                task = hydrateTaskFromProcess(task, targetProcess);
            }
        }
        if (isPackagingTask(task)) {
            const targetProcess = packagingProcessList.find(process => process.fromDate === task.date);
            if (targetProcess) {
                task = hydrateTaskFromProcess(task, targetProcess);
            }
        }
        if (isBrewingTask(task)) {
            const targetProcess = brewingProcessList.find(process => process.fromDate === task.date);
            if (targetProcess) {
                task = hydrateTaskFromProcess(task, targetProcess);
            }
        }

        return task;
    });
}

function hydrateTaskFromProcess(task, process) {
    if (ContentUtils.isEmptyArray(task.process)) {
        task.process = [];
    }
    task.process.push(process);
    return task;
}

function isFermentingTask(task) {
    return ('FILTRATION_TASK' === _.get(task, 'type'));
}

function isBrewingTask(task) {
    return ('BREW_TASK' === _.get(task, 'type'));
}

function isFermentingProcess(process) {
    return _.get(process, 'processSection') === 'FV' || _.get(process, 'processSection') === 'Fermenting' || _.get(process, 'taskId', '').indexOf('FERMENTER_TASK') > -1;
}

function isPackagingProcess(process) {
    return _.get(process, 'processSection') === 'BT' || _.get(process, 'processSection') === 'Packaging'  || _.get(process, 'taskId', '').indexOf('PACKAGING_TASK') > -1;
}

function isBrewingProcess(process) {
    return _.get(process, 'processSection') === 'BH' || _.get(process, 'processSection') === 'Brewing' || _.get(process, 'processSection') === 'BREWHOUSE_TASK' || _.get(process, 'taskId', '').indexOf('BREW_TASK') > -1;
}


function isPackagingTask(task) {
    return 'PACKAGING_TASK' === _.get(task, 'type');
}

function formatTasksProducts(tasks) {
    return _.map(tasks, task => formatTasksProduct(task));
}

function addProductOrderIdToTasks(tasks) {
    return _.map(tasks, task => addProductOrderIdToTask(task));
}

function addProductOrderIdToTask(task) {
    if (!ContentUtils.isEmptyArray(task.products)) {
        task.products = addProductOrderId(task.products);
    }
    return task;
}

function addProductOrderId(products) {
    return _.map(products, product => {
        product.tempId = ContentUtils.getRandomId();
        return product;
    });
}

function formatTasksProduct(task) {
    if (!ContentUtils.isEmptyArray(task.products)) {
        task.products = formatProducts(task.products, task.date);
    }

    task = hydrateTaskWithIconClass(task);
    task.process = _.get(task, 'process') || [];

    return task;
}

function hydrateTaskWithIconClass(task) {

    if (task) {
        const iconTarget = _.find(DashboardServiceCache.getIcons(), icon => _.get(icon, 'name', _.get(icon, 'iconDetail.name')) === task.name);

        if (iconTarget) {
            task.iconClassName = _.get(iconTarget, 'iconDetail.iconClassName');
        }
    }

    return task;
}

function cleanTasks(tasks) {
    return _.map(tasks, task => {
        if (task) {
            task.tasks = undefined;
        }
        return task;
    });
}

function formatProducts(products, taskDate) {
    const productsWithAmount = _.filter(products, product => NumberUtils.getNumber(product.amount) > 0);
    return _.map(productsWithAmount, product => {
        const productAmount = _.get(product, 'amount');
        const endDate = _.get(product, 'endDate') || taskDate;
        return _.assign(product, {
            amount: productAmount,
            endDate: endDate,
            id: _.get(product, 'id'),
            items: formatItems(product.items)
        });
    });
}

function formatItems(productItems) {
    return _.map(productItems, productItem => {
        return _.assign(productItem, {
            id: _.get(productItem, 'id'),
            itemId: _.get(productItem, 'item.id'),
            description: _.get(productItem, 'item.description'),
            amount: productItem.manualAmount || productItem.estimateAmount || productItem.amount || productItem.defaultAmount,
            adjustAmount: productItem.adjustAmount
        });
    });
}

function getAmountOfProduct(product) {

    if (product) {
        return product.manualAmount || product.estimateAmount || product.amount || product.defaultAmount;
    }
    return product;
}

function isSameProcessAndTask(oldOrderProcess, newOrderProcess) {
    const oldProcessId = +_.get(oldOrderProcess, 'processId', +_.get(oldOrderProcess, 'orderProcessHydrated.id'));
    const newProcessId = +_.get(newOrderProcess, 'processId', +_.get(newOrderProcess, 'orderProcessHydrated.id'));

    //@lint-ignore
    return oldProcessId == newProcessId;
}

/**
 * Sort batch by date and column.
 *
 * NOTE: we need to add column tu batch because the sortBy of lodash dont sort by deep child attribute.
 * @param batchs
 * @return {*}
 */
function sortBatchByColumAndDate(batchs) {
    // sort first by dates
    const sortedBatchDates = DateUtils.sortListByDateField(batchs, 'date');
    // group batchs by dates
    const batchGroupByDate = _.groupBy(sortedBatchDates, 'date');
    let sortedBatchs = [];
    // sort individual batch dates by each column of turn
    const batchDates = Object.keys(batchGroupByDate);
    for (const batchDate of batchDates) {
        const batchsByDate = batchGroupByDate[batchDate];
        const batchSortedByColumns = _.sortBy(batchsByDate, 'turn.column');
        sortedBatchs = _.union(sortedBatchs, batchSortedByColumns);
    }
    return sortedBatchs;
}

function getIndexTab(props) {
    let tabsVisibles = [];
    const {isBHAllowed, isFVAllowed, isBTAllowed, order, tankTypeClicked, currentSection, openGeneralTab} = props;

    if (openGeneralTab) {
        return 0;
    }

    tabsVisibles.push({type: 'general_tab'});
    const tankClicked = _.get(props, 'tankClicked.type') || _.get(props, 'tankClicked');
    if (order && order.isSingle) {
        if (tankClicked === 'BH') {
            return 1;
        }
        if (_.get(order.batchs, 'length') > 0) {
            tabsVisibles.push({type: 'BH'});
        }
        if (tankClicked === 'FV') {
            tabsVisibles.push({type: 'FV'});
        } else if (tankClicked === 'BT') {
            tabsVisibles.push({type: 'BT'});
        }
        return _.findIndex(tabsVisibles, type => type.type === currentSection);
    } else {
        if (isBHAllowed) {
            tabsVisibles.push({type: 'BH'});
        }
        if (isFVAllowed) {
            tabsVisibles.push({type: 'FV'});
        }
        if (isBTAllowed) {
            tabsVisibles.push({type: 'BT'});
        }
    }

    return _.findIndex(tabsVisibles, type => type.type === tankTypeClicked);
}

function isEmptyProcess(process) {
    const {toDate, toHour, fromDate, fromHour, note} = process || {};
    return (note === ' ' || note === '' || !note) && !toDate && !toHour && !fromDate && !fromHour && (note === '' || !note);
}

function updateProductOfTask(task, productUpdated) {

    if (task) {
        const products = _.get(task, 'products');
        if (ContentUtils.isEmptyArray(products)) {
            task.products = [productUpdated];
        } else {
            let productTarget = _.find(products, product => _.get(productUpdated, 'id') === _.get(product, 'id'));
            if (ContentUtils.isNull(productTarget)) {
                task.products.push(productUpdated);
            } else {
                task.products = ContentUtils.replaceByAttributes(products, productUpdated, 'id');
            }
        }
    }

    return task;
}

function updateTask(tasks, newTask) {
    const isBrewingSection = newTask && newTask.turn;
    tasks = tasks || [];
    const attributeMatchers = isBrewingSection ? ['date', 'turn.column'] : ['date'];
    const taskTarget = _.find(tasks, task => _.get(task, attributeMatchers) === _.get(newTask, attributeMatchers));
    const existTask = taskTarget !== undefined;
    // update new task
    if (ContentUtils.isEmptyArray(tasks)) {
        return [newTask];
    } else {
        if (existTask) {
            tasks = ContentUtils.replaceByAttributes(tasks, newTask, attributeMatchers);
        } else {
            tasks.push(newTask);
        }
    }

    return _.filter(tasks, task => task); // clean undefined positions
}

function changeLabelName(task, nameValue) {
    return _.set(task, 'label', nameValue);
}

function changeLabelNote(task, nameValue) {
    return _.set(task, 'description', nameValue);
}

function findTaskFromGivenProcess(tasks = [], process = {}) {
    let processDate;

    if (isBrewBatch(process)) {
        processDate = _.get(process, 'fromDate') ||  _.get(process, 'date');
    } else {
        processDate = getDateFromTaskId(process);
    }
    const taskDate = _.filter(tasks, task => _.get(task, 'date') === processDate);

    if (_.get(taskDate, 'length') === 1) {
        return taskDate[0];
    }

    if (isFermentingProcess(process)) {
        return _.find(taskDate, task => task.tankType === 'FERMENTER_TASK');
    }

    if (isPackagingProcess(process)) {
        return _.find(taskDate, task => task.tankType === 'PACKAGING_TASK');
    }

    const batchs = _.filter(taskDate, task => task.tankType !== 'PACKAGING_TASK' && task.tankType !== 'FERMENTER_TASK');

    if (_.get(batchs, 'length') === 1) {
        return batchs[0];
    }

    return _.find(batchs, batch => _.get(batch, 'taskId') === _.get(process, 'taskId'));
}

function isBrewBatch(process) {
    return process && process.processSection === 'Brewing' || process && process.processSection === 'BREWHOUSE_TASK';
}

function getDateFromTaskId(process) {
    if (process && process.taskId) {
        const taskId = process.taskId;
        return taskId.substring(0, taskId.indexOf('_'));
    }
}

function hydrateBatchWithProcess(filteredBatchs, batchs) {
    return _.map(filteredBatchs, filteredBatch => {
        const batchTarget = _.find(batchs, batch =>
            _.get(batch,'turnId') === _.get(filteredBatch, 'turnId') &&
            _.get(batch,'date') === _.get(filteredBatch, 'date')
        );
        if (batchTarget) {
            filteredBatch.process = batchTarget.process;
        }
        return filteredBatch;
    });
}

function updateProcessFromTask(task, newProcess) {

    if (task && ContentUtils.isEmptyArray(task.process)) {
        task.process = [];
    }

    if (task) {
        const existingProcess = _.get(task, 'process', []);
        const processCleaned = _.filter(existingProcess, process => _.get(process, 'processId') !== _.get(newProcess, 'processId')) || [];
        const newProcessFormatted = formatOrderProcess(newProcess);
        task.process = processCleaned.concat(newProcessFormatted);
    }

    return task;
}

function removeProcessFromTasks(tasks, process) {
    const processId = _.get(process, 'processId');
    const taskId = _.get(process, 'taskId');

    return _.map(tasks, task => {
        if (task && (
            _.get(task, 'taskId') === taskId ||
            _.get(task, 'turnId') === taskId)
        ) {
            const existingProcess = _.get(task, 'process', []);
            const processCleaned = _.filter(existingProcess, process =>
                _.get(process, 'processId') != processId) || [];
            task.process = processCleaned;
        }

        return task;
    });

}

module.exports = {
    formatTasksProducts,
    formatTasksProduct,
    formatProducts,
    isEmptyProcess,
    getNonSelectedMenuItem,
    getAmountOfProduct,
    toTankMenuItems,
    toConcreteTask,
    toEmptyTask,
    getTabSelectedIndex,
    retrieveCustomTask,
    getFermenterTank,
    getBriteTank,
    getSingleTank,
    getStyleBeer,
    removeDefaultTaskWhenExistCustom,
    formatProperOrderSelected,
    formatOrderProcess,
    isSameProcessAndTask,
    isToggleChange,
    addProductOrderIdToTasks,
    addProductOrderIdToTask,
    sortBatchByColumAndDate,
    changeLabelName,
    changeLabelNote,
    cleanTasks,
    getIndexTab,
    isSingle,
    setTaskIds,
    updateProductOfTask,
    updateTask,
    fillEachBatchWithProductMissing,
    hydrateOrderWithTheirProcess,
    findTaskFromGivenProcess,
    isPackagingProcess,
    isFermentingProcess,
    isBrewingProcess,
    updateProcessFromTask,
    getTasksFromProcess,
    removeProcessFromTasks,
    hydrateBatchWithProcess,
    getDateFromTaskId
};



/** WEBPACK FOOTER **
 ** ./src/components/DashboardModal/DashboardModalUtils.js
 **/